import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MobileSuccess from '../../assets/images/mobile-success.svg';

import { actionTracking } from '../../store/common/actions';

function ApplicationOTPSuccess() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    dispatch(
      actionTracking({
        url: window.location.href,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!location.state?.path) {
      navigate('/');
    }
  }, [location.state?.path, navigate]);

  return (
    <div className="bg-white p-5">
      <p className="flex-1 text-2xl text-primary2 text-right font-semibold border-b border-gray2 mb-4 pb-4">安全驗證</p>
      <div className="flex justify-center mb-5">
        <img src={MobileSuccess} alt="" />
      </div>
      <p className="text-2xl text-gray text-center">手機驗證成功</p>
      <div className="flex justify-center mt-9 mb-4">
        <button
          onClick={() => navigate(location.state?.path, {
            replace: true, state: {
              phone: location.state?.phone,
              lendela_app_id: location.state?.lendela_app_id,
              no_doc_loan_data: location.state?.no_doc_loan_data
            }
          })}
          className="rounded-full text-white text-xl bg-primary px-12 py-3"
        >
          下一步
        </button>
      </div>
    </div>
  );
}

export default ApplicationOTPSuccess;
